// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b74ab722","453":"bfca7050","455":"73f625fb","977":"9c56e871"}[chunkId] + ".chunk.js";
};